
import { getValueWithoutSymbol, convertCurrency, getFormCampaign } from "../helpers";
import { OtherAmountInput } from "./otherAmountInput";
import { DonationForm } from "../donation/donationForm";
export class PledgeCurrencyAmount {
  handleOtherAmount;
  pledgeRadio;
  currencyInputEl;

  constructor(handleOtherAmountEl,
      pledgeRadioEl = {handlesContainerSelector: "#amount-container", amountRadioNames: "Unchained-Singapore",
        elementValueIndex: 2, labelSelector: ".radio_dark.w-form-label"}, currencyInputEl) {
         this.currencyInputEl = document.getElementById(currencyInputEl);
        this.handleOtherAmount = handleOtherAmountEl ? new OtherAmountInput(handleOtherAmountEl, this.currencyInputEl) : undefined;
        this.pledgeRadio = pledgeRadioEl;
      }
}

export class PledgeRadio {
    donationForm;
    handlesContainer;
    otherAmountInput;
    amountRadios;
    pledgeCurrencyAmount;

    optionsValues = [];
    elementValueIndex;
    labelSelector;
    storageKey;
    currencyCode;
    baseCurrencyCode;
    amountRadioNames;
    isMultiPledge = false;
    //callbacks
    onAmountSelected;
    
  constructor(donationForm, otherAmountInputOrPca, elMap = {handlesContainerSelector: "#amount-container", amountRadioNames: "Unchained-Singapore",
        elementValueIndex: 2, labelSelector: ".radio_dark.w-form-label"}, currencyCode = "SGD") {
      this.donationForm = donationForm instanceof DonationForm ? donationForm : null;
      const isPca = otherAmountInputOrPca instanceof PledgeCurrencyAmount;
      this.pledgeCurrencyAmount = isPca ? otherAmountInputOrPca : undefined;
      this.otherAmountInput = isPca
        ? otherAmountInputOrPca.handleOtherAmount
        : (otherAmountInputOrPca instanceof OtherAmountInput ? otherAmountInputOrPca : undefined);

      const mapping = isPca
        ? (otherAmountInputOrPca.pledgeRadio || elMap)
        : (typeof elMap === "object" && elMap !== null ? elMap : {
            handlesContainerSelector: "#amount-container",
            amountRadioNames: "Unchained-Singapore",
            elementValueIndex: 2,
            labelSelector: ".radio_dark.w-form-label"
          });

      this.currencyCode = isPca
        ? (typeof elMap === "string" ? elMap : currencyCode)
        : (typeof currencyCode === "string" ? currencyCode : "SGD");

      this.handlesContainer = this.donationForm?.form?.querySelectorAll(mapping.handlesContainerSelector)[0] ||
        (mapping.handlesContainerSelector ? document.querySelector(mapping.handlesContainerSelector) : undefined) ||
        this.donationForm?.form?.querySelector(`input[name="${mapping.amountRadioNames}"]`)?.closest(".full-col__input-wrapper");

      this.amountRadios = this.donationForm?.form?.querySelectorAll(`input[name="${mapping.amountRadioNames}"]`) || [];
      this.elementValueIndex = mapping.elementValueIndex ?? 2;
      this.labelSelector = mapping.labelSelector ?? ".radio_dark.w-form-label";
      this.amountRadioNames = mapping.amountRadioNames;
      this.storageKey = getFormCampaign(FCBH.GIVE_FORM).localForm;
      this.baseCurrencyCode = donationForm?.defaultCurrency || "SGD";
      this.createCallbacks();
  }

  createCallbacks() {
    this.amountRadios.forEach(radio => {
        // Remove native required attribute so HTML5 validation does not block submit if user selects only one program
        radio.removeAttribute('required');

        //write pledge message
        //load radios listeners
        let pledgeEl = radio.parentElement.querySelector(this.labelSelector);
        let value = radio.value.split("-");
        let pledgeText = value.length > 1 ? value[1] : "";
        let newAmount = String(value[0]).replaceAll(',', '');
        let content = getValueWithoutSymbol(newAmount, this.currencyCode);
        
        if (!isNaN(content) ) {
            this.optionsValues.push(content);
            this.generateAmountLabel(radio.id, pledgeEl, this.currencyCode, content, pledgeText);
        } else {
            pledgeEl.innerHTML = pledgeEl.innerHTML;
        }

        radio.addEventListener('click', async ({ target }) => {
            // Support toggle uncheck in multi-pledge mode
            if (this.isMultiPledge && target.dataset.wasChecked === "true") {
                target.checked = false;
                target.dataset.wasChecked = "false";
                const customRadio = target.parentElement.querySelector(".w-radio-input");
                if (customRadio) {
                    customRadio.classList.remove("w--redirected-checked");
                }
                if (this.otherAmountInput) {
                    this.otherAmountInput.otherContainer.style.display = 'none';
                    this.otherAmountInput.otherContainer.style.opacity = '0';
                    this.otherAmountInput.otherInput.value = '';
                }
                this.onAmountSelected?.(0, 0, "", this.amountRadioNames);
                return;
            }

            this.amountRadios.forEach(r => {
                r.dataset.wasChecked = (r === target ? "true" : "false");
                const customRadio = r.parentElement.querySelector(".w-radio-input");
                if (customRadio) {
                    if (r === target) customRadio.classList.add("w--redirected-checked");
                    else customRadio.classList.remove("w--redirected-checked");
                }
            });

            let value = target.value.split("-");
            let pledgeText = value.length > 1 ? value[1] : "";
            if (!this.isMultiPledge) {
                this.donationForm.saveFormInStorage("pledge_message", pledgeText);
            }
            let newAmount = String(value[0]).replaceAll(',', '');
            let toCurrency = FCBH.getFromStorage( this.storageKey)?.currency_code ?? this.currencyCode;
            let content = getValueWithoutSymbol(newAmount, toCurrency);
            this.currencyCode = toCurrency;
        
            if (isNaN(content) && this.otherAmountInput){
                if (!this.isMultiPledge) this.donationForm.donationType = 'donate';
                pledgeText = "";
                const usdAmount = toCurrency === 'USD'?this.otherAmountInput.initialValue: await convertCurrency(toCurrency, "USD", this.otherAmountInput.initialValue);
                
                this.otherAmountInput.otherContainer.style.display = 'block'; 
                this.otherAmountInput.otherContainer.style.opacity= '100'; 

                this.otherAmountInput.otherInput.value = this.otherAmountInput.initialValue;
                this.otherAmountInput.otherInput.dispatchEvent(new Event("change"));
                this.onAmountSelected(this.otherAmountInput.otherInput.value, usdAmount, pledgeText, this.amountRadioNames);
            } else {
                if (!this.isMultiPledge) this.donationForm.donationType = 'pledge';
                const usdAmount = toCurrency === 'USD'? content : await convertCurrency(toCurrency, "USD", content);
                if (this.otherAmountInput) this.otherAmountInput.otherContainer.style.display = 'none';
                this.onAmountSelected(content, usdAmount, pledgeText, this.amountRadioNames);            
            }
            if (!this.isMultiPledge) {
                FCBH.saveToStorage(this.storageKey, {
                    ...FCBH.getFromStorage( this.storageKey),
                    "pledge_message": pledgeText
                });
            }
        });
    });

    if (this.otherAmountInput) {
        this.otherAmountInput.otherContainer.style.display = 'none'; 
        this.otherAmountInput.otherContainer.style.opacity= '0'; 
    }
  }

  generateAmountLabel(fromRadioId, pledgeEl, currencyCode, amount, text){ 
      var value = getValueWithoutSymbol(amount, currencyCode);
      var result = `${currency(currencyCode)} ${parseFloat(value).toLocaleString('us-US',{minimumFractionDigits: 2, maximumFractionDigits: 2})} ${text}`;
      pledgeEl.innerHTML = result;
  }

  changeAmountClass(radios){
      radios.forEach(optionNode => {
        const element = optionNode.parentNode.children[this.elementValueIndex];
      });
  }
}
const currency = (currencyCode) => {
    return currencyCode === 'USD' ? "$" : currencyCode + " ";
}